// libraries
import React from "react";
import { connect } from "react-redux";
import { get, startCase } from "lodash";

// store and utils
import * as actions from "../../../store/actions";
import * as ODCalls from "../../../store/calls/indicativeOptionData";
import api from "../../../store/api";

import FormFlowWrapper from "../../theme/wrappers/FormFlowWrapper";
import SelectRateAndTerm from "../../theme/specialized/selectOption/SelectRateAndTerm";

class FundingOptionSelect extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      optionsConfig: [
        {
          term: 5,
          rate: 200,
          scopes: ["solar", "wind"],
          selectedScopes: [],
        },
        {
          term: 10,
          rate: 310,
          scopes: ["wind"],
          selectedScopes: ["wind"],
        },
        {
          term: 15,
          rate: 420,
          scopes: ["solar", "wind"],
          selectedScopes: ["solar"],
        },
      ],
    };
  }

  render() {
    return (
      <FormFlowWrapper>
        <div className={"form-flow-wrapper p20"}>
          <h2
            className={`is-size-2 has-text-primary mb-4 has-text-weight-semibold default-title`}
          >
            Select your funding options
          </h2>
          <div className="tabs">
            <ul>
              <li className="is-active">
                <a>Option 1</a>
              </li>
              <li>
                <a>Option 2</a>
              </li>
              <li>
                <a>Option 3</a>
              </li>
            </ul>
          </div>

          <SelectRateAndTerm
            config={this.state.optionsConfig}
            onSelection={(newConfig) => {
              this.setState({ optionsConfig: [...newConfig] });
            }}
          />

          <section className={"mt-6"}>
            <h3 className={"is-size-3 has-text-primary mb-4 default-subtitle"}>
              Loan Features
            </h3>
            <table
              className={
                "table is-striped is-hoverable is-fullwidth optionpage-table"
              }
            >
              <tr>
                <td className={"has-text-weight-semibold"}>Note:</td>
                <td>
                  Some note about the loan. There could be a lot of text here.
                </td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>
                  Debt Service Method:
                </td>
                <td>You must pay back money through your property taxes.</td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>Note:</td>
                <td>
                  Some note about the loan. There could be a lot of text here.
                </td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>
                  Debt Service Method:
                </td>
                <td>You must pay back money through your property taxes.</td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>Note:</td>
                <td>
                  Some note about the loan. There could be a lot of text here.
                </td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>
                  Debt Service Method:
                </td>
                <td>You must pay back money through your property taxes.</td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>Note:</td>
                <td>
                  Some note about the loan. There could be a lot of text here.
                </td>
              </tr>
              <tr>
                <td className={"has-text-weight-semibold"}>
                  Debt Service Method:
                </td>
                <td>You must pay back money through your property taxes.</td>
              </tr>
            </table>
          </section>
        </div>
      </FormFlowWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  inputs: state.formFlow.inputs,
  computed: state.formFlow.computed,
  optionData: state.indicativeOptionData,
  currStep: state.formFlow.currStep,
  infoFeedDisplay: state.infoFeed,
});

const mapDispatchToProps = (dispatch) => ({
  updateInfoFeedDisplay: (data) =>
    dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
  updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FundingOptionSelect);
